export default {
  data() {
    return {
      statusStrings: {
        'DRAFT': this.$pgettext('statuses', 'Waiting for the package'),
        'READY': this.$pgettext('statuses', 'Ready to be scheduled'),
        'WAITING': this.$pgettext('statuses', 'Searching for Courier'),
        'PROGRAMMED': this.$pgettext('statuses', 'Route programmed'),
        'CONFIRMED': this.$pgettext('statuses', 'Courier in transit to Origin'),
        'ATPICKUPPOINT': this.$pgettext('statuses', 'Courier arrived to Origin'),
        'PICKEDUP': this.$pgettext('statuses', 'Shipping picked up on Origin'),
        'INTRANSIT': this.$pgettext('statuses', 'Courier in transit to Destination'),
        'ATDELIVERYPOINT': this.$pgettext('statuses', 'Courier arrived to Destination'),
        'DELIVERED': this.$pgettext('statuses', 'Shipping delivered'),
        'INCIDENCE': this.$pgettext('statuses', 'On incidence'),
        'WAITINGCLIENT': this.$pgettext('statuses', 'Waiting for Client decision'),
        'CANCELED': this.$pgettext('statuses', 'Canceled'),
        'TOBERETURNED': this.$pgettext('statuses', 'To be returned to Sender'),
        'RETURNED': this.$pgettext('statuses', 'Returned to Sender'),
        'MANIFEST': this.$pgettext('statuses', 'Manifest')
      },
      statusReasonsStrings: {
        error: this.$gettext('Taken by mistake'),
        technical_issue: this.$gettext('Vehicle problem'),
        absent_client: this.$gettext('Absent client'),
        incorrect_address: this.$gettext('Wrong address'),
        unavailable_product: this.$gettext('Unavailable product'),
        unrecognized: this.$gettext('Not accepted'),
        wrong_size: this.$gettext('Wrong package size'),
        rejected: this.$gettext('Not expected'),
        cancelation: this.$gettext('Cancelled by client'),
        cannot_scan_info: this.$gettext('Can\'t scan info'),
        missing_security_code: this.$gettext('Missing security code'),
        out_of_area: this.$gettext('Out of working areas'),
        fraud_risk: this.$gettext('Fraud risk'),
        destroyed: this.$gettext('Package destroyed (I.e.: Credit cards)'),
        lost_package: this.$gettext('Package lost'),
        dangerous_area: this.$gettext('Dangerous area'),
        unrecognized_address: this.$gettext('Unrecognized area'),
        other: this.$gettext('Others')
      },
      statusReasonEvents: {
        'CONFIRMED': this.$pgettext('reasonEvent', 'in transit to origin'),
        'PICKEDUP': this.$pgettext('reasonEvent', 'on origin'),
        'INTRANSIT': this.$pgettext('reasonEvent', 'in transit to destination'),
        'DELIVERED': this.$pgettext('reasonEvent', 'on destination'),
        'RETURNED': this.$pgettext('reasonEvent', 'on returning to sender')
      },
      receiverTypesStrings: {
        same_person_or_family: this.$gettext('Same person or family'),
        neighbour: this.$gettext('Neighbour'),
        doorman: this.$gettext('Doorman')
      },
      currentPicture: '',
      visits: 0,
      void: null
    }
  }
}
